import { skeletonLoader } from 'app/modules/step-engine/utils/step-engine-methods';
import { IRootState } from 'app/shared/reducers';
import React from 'react';
import { useSelector } from 'react-redux';
import { Step, StepEngineStepGroup } from '../../utils/step-engine-constants';
import './claim-declare-steps-engine.scss';

const SkeletonSteps = () => {
    const receivedStep: string[] = useSelector((state: IRootState) => state.stepEngine.stepData.receivedStep);
    const { isMobile, cmsContent } = useSelector((state: IRootState) => state.cms);
    const { lastEditStep } = useSelector((state: IRootState) => state.stepEngine.stepData);

    const { verticalDisplay } = useSelector((state: IRootState) => state.appManagement?.frontConfig);
    const isInVerticalDisplay = verticalDisplay && !isMobile;
    const isLastStepInGroup = (cmsContent[lastEditStep]?.behaviors?.progressBar && (cmsContent[lastEditStep]?.behaviors?.progressBar[1] - cmsContent[lastEditStep]?.behaviors?.progressBar[0] === 1)) || cmsContent[lastEditStep]?.behaviors?.stepGroup === StepEngineStepGroup.SINGLE
    const showGenericSkel = receivedStep === null || isLastStepInGroup;
    const getNextSkeleton = () => {
        return Step[receivedStep[0]];
    };

    const getSkeletonId = () => {
        if (showGenericSkel && isInVerticalDisplay) {
            return "genericVerticalSkel";
        }else if(showGenericSkel){
            return "genericSkel";
        }else {
            if (isInVerticalDisplay) {
                return "verticalSkel";
            }
            else return getNextSkeleton()
        }
    }

    return (
        <div className={(isInVerticalDisplay && !isLastStepInGroup) ? "" : "claim-declaration"}>
            {skeletonLoader(getSkeletonId())}
        </div>
    );
};

export default SkeletonSteps;